module.exports = __webpack_public_path__ + "img/video-camera.370d73c0.svg";